import React, { useMemo, useEffect, useState } from "react";

const shuffleArray = (array) => {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
};

const phrasesList = [
  "Initializing form data",
  "Loading background",
  "Creating data model",
  "Setting up environment",
  "UI components loading"
];

const LoginLoader = () => {
  const phrases = useMemo(() => shuffleArray(phrasesList), []);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % phrases.length);
    }, 1500);
    return () => clearInterval(t);
  }, [phrases.length]);

  return (
    <div id="page">
      <div className="ambient-glow" />

      <div id="phrase_box">
        <svg width="100%" height="100%">
          <text
            className="initText poppinsText"
            fill="#111827"
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            key={idx}
          >
            {phrases[idx]}
          </text>
        </svg>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600&display=swap');

        #page {
          position: absolute;
          inset: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
          overflow: hidden;
        }

        /* Soft ambient moving glow */
        .ambient-glow {
          position: absolute;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(99,102,241,0.08) 0%, transparent 70%);
          filter: blur(60px);
          animation: floatGlow 8s ease-in-out infinite alternate;
        }

        @keyframes floatGlow {
          from { transform: translateY(-20px); }
          to { transform: translateY(20px); }
        }

        #phrase_box {
          height: 60px;
          width: 90%;
          max-width: 520px;
          overflow: hidden;
          position: relative;
          z-index: 2;
        }

        .poppinsText {
          font-family: 'Poppins', sans-serif;
          font-weight: 600;
          font-size: clamp(18px, 2vw, 24px);
          letter-spacing: 0.015em;
        }

        .initText {
          animation: initEnter 1500ms cubic-bezier(.4,0,.2,1) forwards;
        }

        @keyframes initEnter {
          0%   { transform: translateY(28px); opacity: 0; }
          12%  { transform: translateY(0px);  opacity: 1; }
          82%  { transform: translateY(0px);  opacity: 1; }
          100% { transform: translateY(-28px); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default LoginLoader;
